import axios from './axiosConfig';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.demo2.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production'

  ? "https://api.demo2.raborisk.ai"
  : "http://localhost:3000";





export const getReports = () => {

  return (dispatch) => {
    axios
      .get(`${API_URL}/api/reports/get_reports`)
      .then(({ data }) => {
        console.log("Get Reports Data", data)
        dispatch({ type: 'GET_REPORTS_SUCCESS', report: data });
      })
      .catch((error) => {
        dispatch({ type: 'GET_REPORTS_FAILURE', error });
      });
  };
};


export const getReport = (id) => {
  return (dispatch) => {
    axios
      .get(`${API_URL}/api/reports/get_report/${id}`)
      .then(({ data }) => {
        console.log("Get Report Data", data)
        dispatch({ type: 'GET_REPORT_SUCCESS', payload: data });
      })
      .catch((error) => {
        dispatch({ type: 'GET_REPORT_FAILURE', error });
      });
  };
};


export const createReport = (title, reportJson, type) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/reports/create_report",{
        title,
        json: reportJson,
        type: type
      }).then(({ data }) => {
                dispatch({ type: "CREATE_REPORT_SUCCESS", report: data });
                dispatch(getReports());
        });
    };
};

export const deleteReport = (id) => {
    return (dispatch) => {
        axios.delete(API_URL + `/api/reports/delete_report/${id}`)
            .then(({ data }) => {
                dispatch({ type: "REPORT_DELETED", payload: id });
            });
    };
};


export const saveReport = (id, json) => {
    return (dispatch) => {
        axios.put(API_URL + `/api/reports/save_report/${id}`,{
        title: json.editableName.title,
        data: json,
      }).then(({ data }) => {
                console.log("Updated!!")
                dispatch(getReports());
            });
    };
};

export const clearCurrentReport = () => ({
  type: 'CLEAR_CURRENT_REPORT',
});